import { IonButton } from "@ionic/react";
import React, { useState } from "react";
import { User } from "../../models/data";
import { confirmPaymentInfo } from "../../services/pmt_service";


declare global {
    interface Window {
        IframeCheckoutHandler: any;
    }
}

interface PmCompProps {
    totalAmount:any,
    amount: any,
    pmtMethod: any,
    type: string,
    reloading:boolean,
    commition: any,
    method: any,
    user: User
    transactionId:any,
    version:any
    siteText:any
}

const SwFundraiserPayComponent: React.FC<PmCompProps> = (props) => {

    var paymentMethodConfigurationId = props.pmtMethod;

    // Set here the id of the HTML element the payment iframe should be appended to.
    var containerId = 'payment-form';

    var handler = window.IframeCheckoutHandler(paymentMethodConfigurationId);

    document.getElementById('payment-form')!.innerHTML = "";

    handler.setValidationCallback(
        function (validationResult: any) {
            // Reset payment errors
            let errorList: any = document.querySelector('#payment-errors')!;
            errorList.innerHTML = '';

            if (validationResult.success) {
                //Create the order within the shop and eventually update the transaction.
                console.log(validationResult)
                //setSubmitting(true);
                confirmPaymentInfo(props.user,props.totalAmount,props.siteText.userTransactionDonation,props.transactionId,19909,props.version).then(m=>{
                    if(m.message){
                        handler.submit()
                    }
                })
            } else {
                // Display errors to customer
                validationResult.errors.foreach((index: any, errorMessage: any) => {
                    errorList.append('<li>' + errorMessage + '</li>')
                });
            }
        });
    //Set the optional initialize callback
    handler.setInitializeCallback(function () {
        //Execute initialize code
    });


    //Set the optional height change callback
    handler.setHeightChangeCallback(function (height: any) {
        //Execute code
        return 300;
    });

    handler.create(containerId);

    const payHandler = () => {
        handler.validate();

    }

    return (
        <>
            <IonButton disabled={ props.reloading?true:false || !props.pmtMethod} id="pay-button" onClick={payHandler}>{props.type === "credit" ? "Credit account" : "Donate"}</IonButton>
        </>
    )
}

export default SwFundraiserPayComponent;